import styled from "styled-components/macro";

export { DropdownContainer } from "../InviteCandidate/InviteCandidate.styled";

export const SelectedCount = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.theme.colors.faceliftBlue};
  opacity: 0.6;
  margin-bottom: 24px;
  text-align: center;
`;
